
import { constant } from 'constants/constant';
import React, { useEffect, useRef, useState } from 'react'
// import CompanyProfile from '../companyProfile';
import { UserContext } from 'context';
import '../../Setting/companySetting.css'
import { InterFirmList } from '.';
import { TabForInterFirm } from 'components';
import StorageService from 'utils/StorageServices';
import { getFirm } from '_services/accountsServices/firmServices';
import Loading from 'pages/Loading';

const InterFirm = () => {

    const [activeTab, setActiveTab] = useState(1);
    const { settingChild } = React.useContext(UserContext);
    const callBackTab = (data) => {
        setActiveTab(data);
    }
    const [firmDataList, setFirmDataList] = useState([])
    const [loading, setLoading] = useState(false);
    const prevFilterRef = useRef();
    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
    });


    const settingsTabProps = {
        tabList: firmDataList,
        callBackTab: callBackTab,
        activeTab: activeTab
    }

    const getDataFirmList = async () => {
        try {
            let object = {
                ...filter,
                company_id: StorageService.getCompanyId(),
            }
            const res = await getFirm(object);
            if (res?.responseCode == 200) {
                const list = res?.data?.firms?.map((f) => {
                    return ({
                        ...f,
                        name: f?.firm,
                        value: f?._id,
                        label: f?.firm
                    })
                })
                setFirmDataList(list);
                setActiveTab(list[0]);
                setTotalItems(res?.data?.total_record);
            }
        } catch (error) {
            // throw error;
        }
    }

    useEffect(() => {
        const prevFilter = prevFilterRef.current;
        if (
            JSON.stringify(prevFilter) !== JSON.stringify(filter)
        ) {
            getDataFirmList();
            prevFilterRef.current = filter;
        }
    }, [filter])

    const firmListProps = {
        firmDetails: activeTab,
        firmDataLists: firmDataList
    }

    return (
        <>{firmDataList?.length > 0 ? <div className='__settingNwd'>
            <div className='__setNw_left'>
                <div className='__setsHeads'><h4>Inter Firm Ledger </h4></div>

                <TabForInterFirm {...settingsTabProps} invoiceBillRaiseClass="__setNw_tabs" arrowIcon={true} section="setting" />
            </div>

            <div className='__setNw_right'>

                <InterFirmList {...firmListProps} />

            </div>
        </div> : <div className='_tabWith_outTab'><div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}> <Loading /></div></div>}</>

    )
}

export default InterFirm